import type { ReactElement } from 'react';
import { MenuItem, Separator, type SeparatorProps } from 'react-aria-components';
import cx from 'clsx';
import styles from './menu-item-divider.module.css';

export function MenuItemDivider({ className, ...props }: SeparatorProps): ReactElement {
  return (
    <MenuItem>
      <Separator className={cx(styles.separator, className)} {...props} />
    </MenuItem>
  );
}
